import commons from '@/services/commons.service'

class LogService {
  marKNow (name) {
    if (!commons.isProd()) {
      // eslint-disable-next-line no-console
      console.log(name, window.performance.now() / 1000)
    }
  }
}

export default new LogService()
